import { PropsWithChildren } from 'react';
import { withAuthenticationRequired } from 'react-oidc-context';

export const ProtectedWithAuth = withAuthenticationRequired(({ children }: PropsWithChildren) => <>{children}</>);
